import * as core from '../../../../../../../core'
import * as prebuilt from '../../../../../../prebuilt'
import * as summit from '../summit'

export const RESOURCE = {
  payload: {
    alias: 'check-ins',
    appAlias: summit.RESOURCE.payload.alias,
    description: "Let's see how you're doing",
    display: {
      isMain: true,
      position: 1,
    },
    name: 'Check-Ins',
    page: { id: prebuilt.Page.Id.SummitCheckIns },
  },
  type: core.quiver.Resource.Type.AppPage,
} as const satisfies core.quiver.Resource<core.quiver.Resource.Type.AppPage>
